"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Crop_1 = __importDefault(require("./Crop"));
const Proposal_1 = __importDefault(require("./Proposal"));
const emptyData = {
    type: '',
    type_version: '',
    name: '',
    date: '',
    extension: 0,
    extensionUnit: '',
    previewData: {
        lat: 0,
        log: 0,
        score: 0,
        categorie: '',
        qrValid: '',
        qrCode: '',
        resultUrl: '',
        geodata: ''
    },
    crop: new Crop_1.default(),
    proposal: new Proposal_1.default(),
};
class Project {
    constructor(data = emptyData) {
        this.type = data.type || '';
        this.type_version = data.type_version || '';
        this.name = data.name || '';
        this.date = data.date || '';
        this.extension = data.extension || 0;
        this.extensionUnit = data.extensionUnit || '';
        this.previewData = data.previewData || emptyData.previewData;
        this.crop = data.crop || new Crop_1.default();
        this.proposal = data.proposal || new Proposal_1.default();
        this.setGeodata('');
    }
    setGeodata(g) {
        this.previewData.geodata = g;
    }
    async fetchGeodata() {
        try {
            if (this.type !== 'trials') {
                if (this.previewData.geodata.length == 0) {
                    const urlString = this.previewData.resultUrl;
                    const match = urlString.match(/projectId=(\d+)&areaId=(\d+)/);
                    const projectId = match ? match[1] : null;
                    const areaId = match ? match[2] : null;
                    const url = `/project/${projectId}/area/${areaId}/geodata`;
                    const request = await fetch(url);
                    const response = await request.json();
                    this.setGeodata(response.geodata);
                }
            }
        }
        catch (e) {
            console.log(e);
        }
    }
}
exports.default = Project;
